import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { EBasicField } from 'src/app/project/shared/enums/basic-fields-enums';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterNumber,
  TAdvancedFilterSingle,
  TFilterNumberOptions,
} from '../../../../models/advanced-filter.model';
import { ENumberInputUnitPosition } from '../../../input-fields/advanced-filter-number-input/number-input.model';

import {
  IS_EMPTY_NUMERICAL,
  IS_NOT_EMPTY_NUMERICAL,
  numberOperatorWithEqualsToOptions,
  numberSequenceOperatorOptions,
} from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-number',
  templateUrl: './advanced-filter-number.component.html',
  styleUrls: ['./advanced-filter-number.component.scss'],
  standalone: false,
})
export class AdvancedFilterNumberComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();
  @Input() ppType: 'number' | 'sequence_number' | 'cost';

  value: number;
  option: TFilterNumberOptions;
  filter: TAdvancedFilterNumber;
  unit: string;
  unitPosition: ENumberInputUnitPosition;
  decimalPlaces: number;

  advancedFilterNumbersOptions: TSelectOption[];
  EAdvancedFilterOptions = EAdvancedFilterOptions;
  showCommas: boolean;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterNumber;

    this.advancedFilterNumbersOptions =
      this.ppType === 'sequence_number'
        ? numberSequenceOperatorOptions
        : numberOperatorWithEqualsToOptions;

    this.unitPosition =
      this.ppType === 'cost' ? ENumberInputUnitPosition.LEFT : ENumberInputUnitPosition.RIGHT;

    this.value = this.filter.value as number;
    this.option = this.filter.option;
    const field = GET_CUSTOM_FIELDS()[this.filter.id];

    // ID is not a CF
    if (field) {
      this.unit = field.currencySymbol
        ? field.currencyCode + ' ' + field.currencySymbol
        : field.unit; // Makes it work for both cost and numbers
      this.decimalPlaces = +field.decimalPlaces;
      this.showCommas = field.showCommas;
    } else if (this.filter.id === EBasicField.SEQUENCE_NUMBER) {
      this.decimalPlaces = 0;
      this.showCommas = false;
    } else {
      this.decimalPlaces = 2;
      this.showCommas = false;
    }
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterNumberOptions;
    this.option = newCondition.value as TFilterNumberOptions;

    this.ppFilter.operator = newCondition.operator;
    this.ppFilter.option = this.option;

    if (
      this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY ||
      this.ppFilter.option === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      this.filter.value = newCondition.data;
    }

    this.applyChanges();
  }

  applyChanges(): void {
    if (Array.isArray(this.filter.value) && this.filter.value?.every((v) => v === null)) {
      this.filter.value = null;
    }

    if (
      this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY ||
      this.ppFilter.option === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      this.filter.value = (this.ppFilter.option === EAdvancedFilterOptions.IS_EMPTY
        ? IS_EMPTY_NUMERICAL.data
        : IS_NOT_EMPTY_NUMERICAL.data) as unknown as number[];
    }

    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: number): void {
    this.ppFilter.value = value;

    this.applyChanges();
  }
}
